export const normalizeSeq = (seq) => {
  if (seq === null || seq === undefined) return '';
  return String(seq);
};

export const findSeqIndex = (data, seq, seqKey = 'seq') => {
  const seqArray = data?.[seqKey];
  if (!Array.isArray(seqArray)) return -1;

  const targetSeq = normalizeSeq(seq);
  return seqArray.findIndex((itemSeq) => normalizeSeq(itemSeq) === targetSeq);
};

export const hasSeqData = (data, seq, seqKey = 'seq') => findSeqIndex(data, seq, seqKey) !== -1;

export const getSeqValue = (data, field, seq, fallback = undefined, seqKey = 'seq') => {
  const dataIndex = findSeqIndex(data, seq, seqKey);
  if (dataIndex === -1) return fallback;

  const value = data?.[field]?.[dataIndex];
  return value === undefined || value === null ? fallback : value;
};

export const getSeqNestedValue = (
  data,
  field,
  seq,
  childIndex,
  fallback = undefined,
  seqKey = 'seq'
) => {
  const row = getSeqValue(data, field, seq, undefined, seqKey);
  if (!Array.isArray(row)) return fallback;

  const value = row[childIndex];
  return value === undefined || value === null ? fallback : value;
};
